module.exports = __webpack_public_path__ + "img/9C.dbc1a11e.svg";